import { SideBarKey } from '.';
export var createSideBarDriver = function (wrapper) {
    var base = wrapper.$("." + SideBarKey);
    return {
        hasHeader: function () { return base.$('.side-bar-header').exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map